import React, { useState } from 'react';
import { ReactTyped } from 'react-typed';
import {
    FaGithubSquare,
    FaLinkedin,
    FaEnvelopeSquare
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import videoBg from '../Assets/backVid.mp4';
import './Hero.css';

const Hero = () => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <div className='hero-container text-white'>
        <video className='video-bg' src={videoBg} autoPlay loop muted />
        <div className='content px-4'>
            <div className='animate-fadeIn'>
                <div className='flex md:flex-row flex-col items-center justify-between gap-6'>
                    {/* Left: Text content */}
                    <div className='flex-1 md:text-left text-center'>
                        <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold tracking-tight'>
                            Syed Ka Ab Surkhi
                        </h1>
                        <div className='flex md:justify-start justify-center items-center flex-wrap gap-2 mt-2'>
                            <p className='md:text-xl sm:text-lg text-base font-medium text-gray-300'>
                                I'm a 
                            </p>
                            <ReactTyped 
                                className='md:text-xl sm:text-lg text-base font-bold text-[#00d59a]'
                                strings={['Computer Engineer', 'ML Enthusiast', 'Embedded System Developer', 'Robotics Engineer']} 
                                typeSpeed={120} 
                                backSpeed={140} 
                                loop
                            />
                        </div>
                        <div className='flex md:justify-start justify-center gap-4 pt-2'>
                            <Link 
                                to='https://github.com/SurkhiSyed' 
                                target='_blank' 
                                rel='noopener noreferrer'
                                className='transform hover:scale-110 hover:text-[#00d59a] transition-all duration-300'
                            >
                                <FaGithubSquare size={36} />
                            </Link>
                            <Link 
                                to='https://www.linkedin.com/in/syed-kaab-surkhi/' 
                                target='_blank' 
                                rel='noopener noreferrer'
                                className='transform hover:scale-110 hover:text-[#00d59a] transition-all duration-300'
                            >
                                <FaLinkedin size={36} />
                            </Link>
                            <Link 
                                to='https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=ssurkhi56@gmail.com&body=my-text' 
                                target='_blank' 
                                rel='noopener noreferrer'
                                className='transform hover:scale-110 hover:text-[#00d59a] transition-all duration-300'
                            >
                                <FaEnvelopeSquare size={36} />
                            </Link>
                        </div>

                        {/* Resume CTA */}
                        <div className='flex md:justify-start justify-center pt-4 gap-3 flex-wrap'>
                            <a
                                href='/resume-software.pdf'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='px-5 py-2.5 rounded-lg bg-[#00d59a] text-black font-semibold shadow-lg shadow-emerald-500/30 border border-transparent hover:-translate-y-0.5 hover:shadow-xl hover:shadow-emerald-500/40 transition-all duration-300'
                            >
                                Software Resume
                            </a>
                            <a
                                href='/resume-hardware.pdf'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='px-5 py-2.5 rounded-lg bg-white/90 text-black font-semibold shadow-lg shadow-slate-300/40 border border-white/70 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-300/60 transition-all duration-300'
                            >
                                Hardware Resume
                            </a>
                        </div>
                    </div>

                    {/* Right: Profile photo slot */}
                    <div className='flex-1 flex md:justify-end justify-center'>
                        <div className='w-40 h-40 md:w-56 md:h-56 rounded-xl border border-[#00d59a] bg-black/30 backdrop-blur-sm relative overflow-hidden'>
                            <img
                                src='/profile.jpg'
                                alt='Your profile'
                                className='w-full h-full object-cover'
                                onLoad={() => setImgLoaded(true)}
                                onError={() => setImgLoaded(false)}
                            />
                            {!imgLoaded && (
                                <div className='absolute inset-0 flex items-center justify-center text-gray-400 text-sm p-3 text-center'>
                                    Add your photo: place profile.jpg in public/
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Hero;